import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Auslandsadresse, LaenderschluesselEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-auslandsadresse',
  templateUrl: './auslandsadresse.component.html'
})
export class AuslandsadresseComponent extends FormBaseComponent<Auslandsadresse> {

  @Input()
  public showAuslandsAdresse: boolean;
  @Input()
  public auslandRequiredStrasse = false;
  @Input()
  public auslandRequiredHausnumer = false;

  public laenderschluesselEnum = LaenderschluesselEnumLabels;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      strasse: [this.data.strasse, [
        this.validatorService.conditionalValidator(() => this.auslandRequiredStrasse === true, this.validatorService.required()),
        this.validatorService.maxLength(72)
      ]],
      hausnummer: [this.data.hausnummer, [
        this.validatorService.conditionalValidator(() => this.auslandRequiredHausnumer === true, this.validatorService.required()),
        this.validatorService.pattern('^[1-9][0-9]*$',
          this.translateService.instant('COMMON_UI.VALIDATION.HAUSNUMMER_INVALID_PATTERN')),
        this.validatorService.maxLength(4)
      ]],
      hausnummernzusatz: [this.data.hausnummernzusatz, [
        this.validatorService.maxLength(20)
      ]],
      adressergaenzung: [this.data.adressergaenzung, [
        this.validatorService.maxLength(46)
      ]],
      postleitzahl: [this.data.postleitzahl, [
        this.validatorService.required(),
        this.validatorService.maxLength(12)
      ]],
      land: [this.data.land, [
        this.validatorService.required()
      ]],
      ort: [this.data.ort, [
        this.validatorService.required(),
        this.validatorService.maxLength(72)
      ]]
    });
  }
}
